<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <g clip-path="url(#clip0_56_698)">
      <path
        d="M9.59623 16.3031L5.42623 12.1331L4.00623 13.5431L9.59623 19.1331L21.5962 7.13314L20.1862 5.72314L9.59623 16.3031Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_56_698">
        <rect width="24" height="24" fill="white" transform="translate(0.596191 0.133301)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped lang="postcss"></style>
